import type { OntologyEntry } from '../types.js';

/**
 * Source tier taxonomy — absorbed from IntelHub's `source_tier` pg enum
 * (Phase 1 Semantic Dedup, 2026-04-18). Higher numericValue = more authoritative.
 *
 * tierLabel ('T1'..'T4') matches the dedup spec §5.2 / §5.8 notation.
 *
 * IntelHub DB: `sources.tier` column uses matching kebab-case slugs verbatim
 * (no bridge needed — the pg enum values are authored as
 * 'authoritative' / 'research' / 'specialist' / 'general').
 */
export const sourceTiers: OntologyEntry[] = [
  {
    slug: 'authoritative',
    name: 'Authoritative',
    description: 'Primary, official source — government CERTs, vendor PSIRT, standards bodies (e.g. CISA, MSRC, MITRE, NVD).',
    dimension: 'source-tier',
    sortOrder: 0,
    metadata: { numericValue: 4, tierLabel: 'T1' },
  },
  {
    slug: 'research',
    name: 'Research',
    description: 'Vendor threat-intelligence research arms and reputable security research groups (e.g. Mandiant, Google TAG, CrowdStrike Intelligence).',
    dimension: 'source-tier',
    sortOrder: 1,
    metadata: { numericValue: 3, tierLabel: 'T2' },
  },
  {
    slug: 'specialist',
    name: 'Specialist',
    description: 'Independent cybersecurity trade press with editorial standards (e.g. BleepingComputer, Dark Reading, SecurityWeek, KrebsOnSecurity).',
    dimension: 'source-tier',
    sortOrder: 2,
    metadata: { numericValue: 2, tierLabel: 'T3' },
  },
  {
    slug: 'general',
    name: 'General',
    description: 'General-interest tech/news sources covering cybersecurity. Default for unclassified feeds.',
    dimension: 'source-tier',
    sortOrder: 3,
    metadata: { numericValue: 1, tierLabel: 'T4' },
  },
];
